/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for Teams integration healthcheck job.

- verify_graph_access: attempt a lightweight Graph API call to ensure token and permissions
- verify_global_subscriptions: check calendar events and transcripts subscription presence
- verify_meeting_subscriptions: sample-check per-meeting meetingCallEvents subscriptions for upcoming slots
- sample_slots_hours: horizon to sample upcoming slots when verifying per-meeting subscriptions
 */
export interface TeamsHealthcheckParams {
  verifyGraphAccess?: boolean;
  verifyGlobalSubscriptions?: boolean;
  verifyMeetingSubscriptions?: boolean;
  sampleSlotsHours?: number;
}
